export const data = [
  {
    id: 1,
    img: "https://images.unsplash.com/photo-1473968512647-3e447244af8f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    title: "Beautiful village apartment in Jerusalem mountains",
    subTitle: "Entire rental unit in Mahseya",
    details: "6guests - 3 bedrooms - 3 beds - 2 baths",
    subDetails: "Wifi - Kitchen - Washer - Air conditioning",
    review: "4.88",
    totalReview: "(16 reviews)",
    price: "1,121 / night",
    totalPrice: "10,088 total",
  },
  {
    id: 2,
    img: "https://images.unsplash.com/photo-1521405924368-64c5b84bec60?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
    title: "Vacation apartment",
    subTitle: "Entire rental unit in Tzur Hadassah",
    details: "4guests - 3 bedrooms - 3 bed - 2 bath",
    subDetails: "Wifi - Kitchen - Washer - Air conditioning",
    review: "5",
    totalReview: "(5 reviews)",
    price: "545 / night",
    totalPrice: "4,907 total",
  },
  {
    id: 3,
    img: "https://images.unsplash.com/photo-1524143986875-3b098d78b363?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    title: "Tali's place",
    subTitle: "Entire rental unit in Tzur Hadassah",
    details: "4guests - 1 bedrooms - 4 beds - q bath",
    subDetails: "Wifi - Kitchen - Washer - Air conditioning",
    review: "4.88",
    totalReview: "(16 reviews)",
    price: "1,121 / night",
    totalPrice: "10,088 total",
  },
];
